import PropTypes from 'prop-types';

const ListIcon = ({toggleColor}) => {
    return (
        <div>
           <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="vuesax/linear/task">
            <g id="vuesax/linear/task_2">
            <g id="task">
            <path id="Vector" d="M9.80273 21.7822H21" stroke={toggleColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector_2" d="M9.80273 12.2578H21" stroke={toggleColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector_3" d="M9.80273 2.78516H21" stroke={toggleColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            </g>
            <circle id="Ellipse 2" cx="4.48633" cy="2.74414" r="1.48633" fill={toggleColor}/>
            <circle id="Ellipse 3" cx="4.48633" cy="12.7168" r="1.48633" fill={toggleColor}/>
            <circle id="Ellipse 4" cx="4.48633" cy="22.6895" r="1.48633" fill={toggleColor}/>
            </g>
            </svg>
        </div>
    )
}
ListIcon.propTypes = {
    toggleColor:PropTypes.string
};

export default ListIcon;